import { render, staticRenderFns } from "./TooltipTrennungsabstandsberechnung.vue?vue&type=template&id=58234a1a&scoped=true&"
import script from "./TooltipTrennungsabstandsberechnung.vue?vue&type=script&lang=js&"
export * from "./TooltipTrennungsabstandsberechnung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58234a1a",
  null
  
)

export default component.exports